'use client';

import { cn } from '@fshr/shared-react';
import TableCell from '../cells/table-cell';
import {
	getCellLayoutClassName,
	getColumnStyle,
	getStickyFirstColumnClassName,
} from './cell-layout';
import type { TableCellLayoutContext } from './types';
import type { ProcessedCell } from '../types';

interface SortableTableBodyProps extends TableCellLayoutContext {
	processedRows: ProcessedCell[][];
	visibleIndices: number[];
}

export default function SortableTableBody({
	processedRows,
	visibleIndices,
	columnWidths,
	layoutMode,
	isHorizontalOverflow,
	isCompressed,
	hasColumnWidths,
	stickyRowHeader,
	isStickyScrolled,
	rowClassName,
}: SortableTableBodyProps) {
	return (
		<div role="rowgroup" className="flex flex-col">
			{visibleIndices.map(rowIndex => (
				<div
					key={rowIndex}
					role="row"
					data-sortable-row
					className={cn(rowClassName, 'group/row hover:bg-button-primary-ghost-hover')}
				>
					{processedRows[rowIndex].map((cell, colIndex) => (
						<div
							key={colIndex}
							role="cell"
							data-sortable-cell
							data-cell-role="body"
							data-column-index={colIndex}
							style={getColumnStyle(colIndex, columnWidths, layoutMode)}
							className={cn(
								'group/cell flex h-[60px] max-h-[60px] items-center md:h-[75px] md:max-h-[75px]',
								getCellLayoutClassName(
									colIndex,
									isHorizontalOverflow,
									isCompressed,
									hasColumnWidths
								),
								getStickyFirstColumnClassName(
									colIndex,
									stickyRowHeader,
									isHorizontalOverflow,
									isStickyScrolled,
									false
								),
								cell.hideOnMobile && 'hidden min-[700px]:flex'
							)}
						>
							<TableCell cell={cell} columnIndex={colIndex} />
						</div>
					))}
				</div>
			))}
		</div>
	);
}
